module.exports = __webpack_public_path__ + "img/driver-opaque.jpg";